import styles from "./ScrollStyles.module.scss";
import CheckColorIcon from "@Icons/CheckColorIcon";
import EyeFactsIcon from "@Icons/EyeFactsIcon";
import MetaFactsPhoneIcon from "@Icons/MetaFactsPhoneIcon";
import MetaFactsFileIcon from "@Icons/MetaFactsFileIcon";
import HeartFillIcon from "@Icons/HeartFillIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

type FactsScrollPropType = {
  data?: any;
  fromProperty?: boolean;
  isDesktop?: boolean;
};

const icons: { [key: string]: { [key: string]: JSX.Element } } = {
  shortlist: {
    mobile: <HeartFillIcon fill="#3F83F8" height="14" />,
    desktop: <HeartFillIcon fill="#3F83F8" height="16" />,
  },
  enquire: {
    mobile: <MetaFactsPhoneIcon />,
    desktop: <MetaFactsPhoneIcon height="16" width="16" />,
  },
  booking: {
    mobile: <MetaFactsFileIcon />,
    desktop: <MetaFactsFileIcon height="16" width="16" />,
  },
  view: {
    mobile: <EyeFactsIcon width={14} height={12} fill="#3F83F8" />,
    desktop: <EyeFactsIcon width={16} height={14} fill="#3F83F8" />,
  },
};

const getFactIcon = (name: string, isDesktop = false) => {
  const keywords = ["shortlist", "booking", "enquire", "view"];
  if (name) {
    const word = keywords.find((value) => name.includes(value));
    return word ? icons[word][isDesktop ? "desktop" : "mobile"] : <CheckColorIcon />;
  }
  return <CheckColorIcon />;
};

const FactsScroll = ({ data, fromProperty, isDesktop }: FactsScrollPropType) => {
  const isHappyFlow = true;

  return (
    <>
      {data?.value ? (
        <div
          className={formatClassNames(
            styles.factsParentContainer,
            isHappyFlow && !fromProperty ? styles.happyFlowFactsParentContainer : "",
            fromProperty && styles.fromProperty,
          )}
        >
          <div
            className={formatClassNames(
              styles.factsJourneyContainer,
              isDesktop && fromProperty ? styles.factsJourneyContainerDesktop : "",
              isHappyFlow && !fromProperty ? styles.happyFlowFactsJourneyContainer : "",
              isHappyFlow && isDesktop && !fromProperty ? styles.desktopFactsJourneyContainer : "",
            )}
          >
            <div className={formatClassNames(styles.iconContainer, styles.blueIcon)}>
              {getFactIcon(data?.name, isDesktop)}
            </div>
            <div
              className={formatClassNames(
                styles.infoFacts,
                isHappyFlow ? styles.happyFlowInfo : "",
                isHappyFlow && isDesktop ? styles.desktopInfo : "",
              )}
            >
              <div
                className={formatClassNames(
                  styles.factValue,
                  isHappyFlow ? styles.happyFlowFactValue : "",
                )}
              >
                {data?.value}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default wrapperHOC(FactsScroll, {
  componentName: "FactsScroll-PropertyDetailsSection-PropertyPage",
  showForChina: true,
});
